import { useEffect, useState } from 'react';

function useGeoLocation() {
  const [location, setLocationState] = useState(null);
  const [permissionDenied, setPermissionDenied] = useState(false);

  useEffect(() => {
    navigator.permissions
      ?.query({ name: 'geolocation' })
      .then((result) => {
        if (result.state === 'granted') {
          navigator.geolocation.getCurrentPosition((position) => {
            setLocationState({
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
            });
          });
        }
        if (result.state === 'denied') {
          setPermissionDenied(true);
          setLocationState(null);
        }
      })
      .catch(() => {
        setPermissionDenied(true);
      });
  }, []);

  const requestLocationPermission = () => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        setLocationState({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        });
      },
      () => {
        setPermissionDenied(true);
        setLocationState(null);
      }
    );
  };

  return {
    location,
    permissionDenied,
    onRequestPermission: requestLocationPermission,
  };
}

export default useGeoLocation;
